import React from "react";

const SearchFilter = ({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  genderFilter,
  setGenderFilter,
  requestStartDate,
  setRequestStartDate,
  requestEndDate,
  setRequestEndDate,
  reportedStartDate,
  setReportedStartDate,
  reportedEndDate,
  setReportedEndDate,
  patientStartDate,
  setPatientStartDate,
  patientEndDate,
  setPatientEndDate,
  statusOptions = ["Pending", "Assigned", "Completed"],
  genderOptions = ["Male", "Female"],
}) => {
  return (
    <div className="date-filters">
      {setSearchTerm && (
        <div className="date-filter-group-search">
          <h4>Search</h4>
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm || ""}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      )}

      {setStatusFilter && (
        <div className="date-filter-group-select">
          <h4>Status</h4>
          <select
            value={statusFilter || ""}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="status-select"
          >
            <option value="">All Status</option>
            {statusOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}

      {setGenderFilter && (
        <div className="date-filter-group-select">
          <h4>Gender</h4>
          <select
            value={genderFilter || ""}
            onChange={(e) => setGenderFilter(e.target.value)}
            className="status-select"
          >
            <option value="">All</option>
            {genderOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}

      {(setRequestStartDate || setRequestEndDate) && (
        <div className="date-filter-group">
          <h4>Request Date Range</h4>
          {setRequestStartDate && (
            <label>
              Start :
              <input
                className="styled-date"
                type="date"
                value={requestStartDate || ""}
                onChange={(e) => setRequestStartDate(e.target.value)}
              />
            </label>
          )}
          {setRequestEndDate && (
            <label>
              End :
              <input
                className="styled-date"
                type="date"
                value={requestEndDate || ""}
                onChange={(e) => setRequestEndDate(e.target.value)}
              />
            </label>
          )}
        </div>
      )}

      {(setReportedStartDate || setReportedEndDate) && (
        <div className="date-filter-group">
          <h4>Report Date Range</h4>
          {setReportedStartDate && (
            <label>
              Start :
              <input
                className="styled-date"
                type="date"
                value={reportedStartDate || ""}
                onChange={(e) => setReportedStartDate(e.target.value)}
              />
            </label>
          )}
          {setReportedEndDate && (
            <label>
              End :
              <input
                className="styled-date"
                type="date"
                value={reportedEndDate || ""}
                onChange={(e) => setReportedEndDate(e.target.value)}
              />
            </label>
          )}
        </div>
      )}

      {(setPatientStartDate || setPatientEndDate) && (
        <div className="date-filter-group">
          <h4>Registered date</h4>
          {setPatientStartDate && (
            <label>
              Start :
              <input
                className="styled-date"
                type="date"
                value={patientStartDate || ""}
                onChange={(e) => setPatientStartDate(e.target.value)}
              />
            </label>
          )}
          {setPatientEndDate && (
            <label>
              End :
              <input
                className="styled-date"
                type="date"
                value={patientEndDate || ""}
                onChange={(e) => setPatientEndDate(e.target.value)}
              />
            </label>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchFilter;
